import { extendTheme } from '@chakra-ui/react';

const fonts = {
    // heading: 'Raleway',
};

const colors = {
    transparent: 'transparent',
    brand: {
        900: '#1a365d',
        800: '#153e75',
        700: '#2a69ac',
    },
    blue: {
        500: '#0F2C53',
    },
};

const components = {
    Text: {
        baseStyle: {},
    },
    Heading: {
        baseStyle: {},
        sizes: {},
        variants: {
            white: {
                color: 'white',
            },
        },
    },
    Code: {
        variants: {
            'mnemonic-word': {
                fontWeight: 'bold',
                boxShadow: '1px 2px 4px lightgray',
                borderRadius: 5,
                padding: 2,
                margin: 2,
            },
            'mnemonic-word-selected': {
                fontWeight: 'bold',
                boxShadow: '1px 2px 4px lightgray',
                borderRadius: 5,
                padding: 2,
                margin: 2,
                backgroundColor: 'blue.500',
                color: 'white',
            },
        },
    },
    Box: {
        variants: {
            menu: {
                fontWeight: 'bold',
            },
            p: ({ colorMode }: any) => {
                return {
                    bg: 'red',
                };
            },
        },
    },
    Table: {
        // customize table style
    },
};

export default extendTheme({ colors, components, fonts });
